export default {"src":"/_next/static/media/superimpose.adcbfea3.gif","height":600,"width":1000,"blurWidth":0,"blurHeight":0};